<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="page-title">
          <h1>Run Sheets</h1>
        </div>
      </div>
      <div class="col-lg-6 text-right">
        <div class="m-t-md">
        </div>
      </div>
    </div>
    <!-- /.row -->

    <div class="portlet portlet-default">
      <div class="portlet-heading">
        <div class="portlet-title">
          <h4>Find Run Sheet</h4>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="portlet-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group m-b-sm">
              <label class="control-label">Run ID</label>
              <input
                type="text"
                class="form-control"
                :value="filters.run"
                @input="updateRunValue"
              />
            </div>
            <!-- /.form-group -->
          </div>
          <div class="col-md-3">
            <div class="form-group m-b-sm">
              <label class="control-label">Date Created</label>

              <div class="input-group">
                <flatpickr
                  class="form-group"
                  :config="flatpickrOptions"
                  :value="filters.created"
                  @on-change="dateCreatedChanged"
                  @on-close="dateCreatedClosed"
                />

                <span class="input-group-addon" data-clear>
                  <font-awesome :icon="['far', 'times']" />
                </span>
              </div>
            </div>
            <!-- /.form-group -->
          </div>
          <div class="col-md-3">
            <div class="form-group m-b-sm">
              <label class="control-label">Driver</label>
              <multiselect
                placeholder=""
                preselect-first
                :options="driverOptions"
                :allow-empty="false"
                track-by="id"
                label="name"
                :show-labels="false"
                v-model="driver"
              />
            </div>
            <!-- /.form-group -->
          </div>
          <div class="col-md-3">
            <div class="form-group m-b-sm">
              <label class="control-label">Status</label>
              <multiselect
                placeholder=""
                preselect-first
                :options="statusOptions"
                v-model="status"
                track-by="value"
                label="name"
                :show-labels="false"
              />
            </div>
            <!-- /.form-group -->
          </div>
        </div>
        <!-- /.row -->
      </div>
    </div>
    <!-- /.portlet -->

    <div v-if="meta && meta.incomplete.length > 0" class="alert alert-danger" role="alert">
      <div class="container-fluid">
        <div class="row">
          <div class="col-1 text-center">
            <strong class="text-danger">The following Runs have incompleted stops</strong>
            <ul class="list-unstyled">
              <li v-for="run in meta.incomplete" :key="run.id">
                <router-link class="alert-link" :to="{ name: 'delivery-runs.run-sheet', params: { id: run.id } }" exact>
                  Run #{{ run.id }} has {{ run.stops_count }} Stops incomplete
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <infinite-scroll @load="load" ref="infinite">
      <template v-slot:loading="{ invisible }">
        <loading-spinner
          :class="{ invisible: invisible && !searchingDrivers }"
        />
      </template>
      <ul class="list-data has-button-right">
        <li class="data-heading visible-md visible-lg">
          <div class="row">
            <div class="col-md-1 col-lg-1">
              <p>ID</p>
            </div>
            <div class="col-md-2 col-lg-2">
              <p>Driver</p>
            </div>
            <div class="col-md-4 col-lg-4">
              <p>Stations</p>
            </div>
            <div class="col-md-2 col-lg-2">
              <p>Created At</p>
            </div>
            <div class="col-md-1 col-lg-1">
              <p>Stops</p>
            </div>
            <div class="col-md-2 col-lg-2 text-sm-right">
              <p>Status</p>
            </div>
          </div>
          <!-- /.row -->
        </li>
        <li v-for="deliveryRun in deliveryRuns" :key="deliveryRun.id">
          <router-link
            :to="{
              name: 'delivery-runs.run-sheet',
              params: { id: deliveryRun.id },
            }"
          >
            <div class="row">
              <div class="col-xs-6 col-sm-5 col-md-1 col-lg-1">
                <p>
                  <span class="data-label hidden-md hidden-lg">ID</span>
                  {{ deliveryRun.id }}
                </p>
              </div>
              <div class="col-xs-6 col-sm-7 col-md-2 col-lg-2">
                <p class="text-truncate">
                  <span class="data-label hidden-md hidden-lg">Driver</span>

                  {{ deliveryRun.driver_name }}
                </p>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <p class="text-truncate">
                  <span class="data-label hidden-md hidden-lg">Stations</span>
                  {{ deliveryRun.fire_stations }}
                </p>
              </div>
              <div class="col-xs-6 col-sm-5 col-md-2 col-lg-2">
                <p class="text-truncate">
                  <span class="data-label hidden-md hidden-lg">Created At</span>

                  {{
                    deliveryRun.created_at
                      | date({ format: "DD/MM/YYYY h:mma", utc: false })
                  }}
                </p>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-1 col-lg-1">
                <p>
                  <span class="data-label hidden-md hidden-lg">Stops</span>
                  {{ deliveryRun.stops_count }}
                </p>
              </div>
              <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
                <p class="text-sm-right">
                  <span class="data-label hidden-md hidden-lg">Status</span>
                  <span
                    class="status"
                    :class="statusClass(deliveryRun.status)"
                    >{{ deliveryRun.status }}</span
                  >
                </p>
              </div>
            </div>
            <!-- /.row -->
          </router-link>
          <router-link
            tag="button"
            class="btn btn-info"
            :disabled="deliveryRun.started === false"
            :to="{
              name: 'delivery-runs.run-sheet.stop',
              params: { id: deliveryRun.id },
            }"
          >
            <font-awesome :icon="['far', 'road']" />
          </router-link>
        </li>
      </ul>
      <!-- /.list-data -->
    </infinite-scroll>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'
import { appliesFilters } from '@codium/codium-vue'
import { http } from 'utils'
import Flatpickr from 'vue-flatpickr-component'
import moment from 'moment'

export default {
  mixins: [appliesFilters],

  components: {
    Flatpickr
  },

  data () {
    return {
      searchingDrivers: false,
      statusOptions: [
        { name: 'Default', value: null },
        { name: 'Unassigned', value: 1 },
        { name: 'Assigned', value: 2 },
        { name: 'Started', value: 3 },
        { name: 'Complete', value: 4 }
      ],
      filters: {
        run: null,
        status: null,
        driver: 'all',
        created_start: null,
        created_end: null
      }
    }
  },

  async created () {
    await this.getDrivers()
    await this.getDeliveryRuns()
  },

  beforeDestroy () {
    this.resetDeliveryRuns()
  },

  watch: {
    async queryParams () {
      try {
        this.searchingDrivers = true

        this.resetDeliveryRuns()

        await this.getDeliveryRuns(this.queryParams)

        this.searchingDrivers = false

        this.$refs.infinite.restart()
      } catch (error) {
        // Likely no more results thrown...
      }
    }
  },

  channel (vm) {
    return `delivery-run`
  },

  echo: {
    'DeliveryRun.Created': (payload, vm) => {
      vm.resetDeliveryRuns()
      vm.getDeliveryRuns(vm.queryParams)
    },
    'DeliveryRun.Calculated': (payload, vm) => {
      vm.resetDeliveryRuns()
      vm.getDeliveryRuns(vm.queryParams)
    }
  },

  computed: {
    flatpickrOptions () {
      return {
        mode: 'range',
        altInput: true,
        allowInput: true,
        wrap: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d',
        defaultDate: [this.filters.created_start, this.filters.created_end]
      }
    },

    status: {
      get () {
        return this.statusOptions.find(
          ({ value }) => value === this.filters.status
        )
      },

      set (option) {
        if (option) {
          this.filters.status = option.value
        } else {
          this.filters.status = null
        }
      }
    },

    driverOptions () {
      return [{ id: 'all', name: 'All Drivers' }].concat(this.drivers)
    },

    driver: {
      get () {
        if (this.filters.driver === 'all') {
          return { id: 'all', name: 'All Drivers' }
        }

        return this.drivers.find(
          ({ id }) => id === parseInt(this.filters.driver)
        )
      },

      set (value) {
        if (value) {
          this.filters.driver = value.id
        } else {
          this.filters.driver = null
        }
      }
    },

    ...mapState('deliveryRuns', ['deliveryRuns', 'meta']),
    ...mapState('drivers', ['drivers'])
  },

  methods: {
    ...mapActions('deliveryRuns', ['getDeliveryRuns', 'resetDeliveryRuns']),
    ...mapActions('drivers', ['getDrivers']),

    async addBlankRun () {
      try {
        const response = await http.post('delivery-runs/blank')

        this.$router.push({
          name: 'delivery-runs.run-sheet',
          params: { id: response.data.data.id }
        })
      } catch (error) {
        this.$notify('error', 'Something went wrong when adding a new run.')
      }
    },

    updateRunValue: debounce(function (event) {
      this.filters.run = event.target.value
    }, 750),

    dateCreatedClosed (dates) {
      if (dates.length < 2) {
        this.filters.created_start = null
        this.filters.created_end = null
      }
    },

    dateCreatedChanged (dates) {
      if (dates.length === 2) {
        const [start, end] = dates.map((date) =>
          moment(date).format('YYYY-MM-DD')
        )

        this.filters.created_start = start
        this.filters.created_end = end
      } else if (dates.length === 0) {
        this.filters.created_start = null
        this.filters.created_end = null
      }
    },

    deliveryRunNotStarted (status) {
      return status === 'Unassigned' || status === 'Assigned'
    },

    statusClass (status) {
      const map = {
        Unassigned: 'status-default',
        Assigned: 'status-info',
        Started: 'status-warning',
        Complete: 'status-success',
        'Generating..': 'status-default',
        Failed: 'status-danger'
      }

      return map[status]
    },

    async load (done) {
      try {
        await this.getDeliveryRuns(this.queryParams)

        done()
      } catch (error) {
        done(true)
      }
    }
  }
}
</script>
